(() => {
  if (customElements.get("featured-collection")) {
    return;
  }

  class FeaturedCollection extends HTMLElement {
    constructor() {
      super();

      this.slider = {};
      this.controls = this.querySelectorAll("[data-control]");
      this.prevArrow = this.querySelector("[data-prev]");
      this.nextArrow = this.querySelector("[data-next]");

      this.controls.forEach((control) => {
        control.addEventListener("click", this.onControlClick.bind(this));
      });
    }

    connectedCallback() {
      const slider = this.querySelector("[data-slider]");

      if (!slider) {
        return;
      }

      this.slider = new Splide(slider, {
        pagination: false,
        rewind: false,
        waitForTransition: false,
        arrows: false,
        width: "calc(428 / 620 * 100%)",
        gap: "20px",
        fixedWidth: "calc(50% - 10px)",
        perMove: 1,
        breakpoints: {
          1200: {
            width: "90%",
          },
          990: {
            width: "calc(100%)",
            arrows: false,
            gap: "20px",
            fixedWidth: "200px",
          },
        },
      }).mount();

      // Add class to show slider after mount
      slider.classList.add("is-initialized");

      // Initialize progress bar
      const progressBar = this.querySelector("[data-progress-bar]");
      if (progressBar) {
        const updateProgress = () => {
          const end = this.slider.Components.Controller.getEnd() + 1;
          const rate = Math.min((this.slider.index + 1) / end, 1);

          // Check if track has overflow by comparing DOM dimensions
          const track = this.slider.Components.Elements.track;
          const hasOverflow = track.scrollWidth > track.clientWidth;

          // Hide progress bar when all slides fit in viewport (no scrolling needed)
          if (!hasOverflow) {
            progressBar.parentElement.style.display = "none";
            return;
          }

          progressBar.parentElement.style.display = "block";
          progressBar.style.width = String(100 * rate) + "%";
        };

        this.slider.on("mounted move", updateProgress);
        requestAnimationFrame(() => updateProgress());
      }

      this.slider.on("move", (newIndex, prevIndex, destIndex) => {
        this.nextArrow.classList.toggle(
          "hidden",
          destIndex + 1 >= this.slider.length - 1,
        );
        this.prevArrow.classList.toggle("hidden", destIndex === 0);
      });

      this.slider.on("drag", (e) => {
        if (window.disableParentSliderDrag) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      });
    }

    onControlClick(event) {
      event.preventDefault();

      if (this.slider === {}) {
        return;
      }

      const action = event.currentTarget.hasAttribute("data-prev") ? "<" : ">";

      this.slider.go(action);
    }
  }

  customElements.define("featured-collection", FeaturedCollection);
})();
